// Components
import { SMPDrawIcon, SMPLossIcon, SMPWinIcon, Tooltip } from '../../../index';

// Types
import { INormalizedTeamForm } from '../../../../types';

export interface IFormIconProps {
  form: INormalizedTeamForm;
}

export const FormIcon = ({ form }: IFormIconProps): JSX.Element => {
  const { outcome, startTime, matchSummary } = form;

  return (
    <Tooltip text={matchSummary} overlineText={startTime}>
      {
        {
          W: <SMPWinIcon width='3' height='3' />,
          L: <SMPLossIcon width='3' height='3' />,
          D: <SMPDrawIcon width='3' height='3' />,
        }[outcome]
      }
    </Tooltip>
  );
};
